// Generated by ReScript, PLEASE EDIT WITH CARE


function scoreToTrophy(score) {
  if (score < 70) {
    return "Glass";
  } else if (score < 80) {
    return "Bronze";
  } else if (score < 90) {
    return "Silver";
  } else {
    return "Gold";
  }
}

export {
  scoreToTrophy ,
}
/* No side effect */
